import PropTypes from 'prop-types';
// @mui
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel, Tooltip } from '@mui/material';
import Iconify from '../Iconify';

// ----------------------------------------------------------------------

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
};

// ----------------------------------------------------------------------

TableHeadCustom.propTypes = {
  onSort: PropTypes.func,
  orderBy: PropTypes.string,
  headLabel: PropTypes.array,
  isDraggable: PropTypes.bool,
  resetDragAndDrop: PropTypes.func,
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSelectAllRows: PropTypes.func,
  order: PropTypes.oneOf(['asc', 'desc']),
  sx: PropTypes.object,
};

export default function TableHeadCustom({
  order,
  orderBy,
  rowCount = 0,
  headLabel,
  isDraggable = false,
  resetDragAndDrop,
  numSelected = 0,
  onSort,
  onSelectAllRows,
  sx,
}) {
  return (
    <TableHead sx={{ position: 'relative', zIndex: 20, ...sx }}>
      <TableRow>
        {!isDraggable && onSelectAllRows && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={(event) => onSelectAllRows(event.target.checked)}
            />
          </TableCell>
        )}

        {isDraggable && (
          <Tooltip
            title="ریست"
            placement="top"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [-10, -20],
                    },
                  },
                ],
              },
            }}
          >
            <TableCell padding="checkbox">
              <div onClick={resetDragAndDrop} className="flex justify-center items-center cursor-pointer">
                <Iconify icon="material-symbols:reset-settings-rounded" width={24} height={24} />
              </div>
            </TableCell>
          </Tooltip>
        )}

        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            className={!!headCell.stickyCell ? 'fixed-table-cell' : ''}
            align={headCell.align || 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ width: headCell.width, minWidth: headCell.minWidth }}
          // sx={{ width: headCell.width, minWidth: headCell.minWidth, padding: '10px', fontSize: '0.8rem', lineHeight: '1.2rem' }}
          >
            <div
              className={`flex items-center gap-1 ${headCell.align === 'center' ? 'justify-center' : 'justify-start'
                }`}
            >
              {onSort ? (
                <TableSortLabel
                  hideSortIcon
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={() => onSort(headCell.id)}
                  sx={{ textTransform: 'capitalize' }}
                >
                  {headCell.label}

                  {orderBy === headCell.id ? (
                    <Box sx={{ ...visuallyHidden }}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
              {!!headCell.tooltip && (
                <Tooltip title={headCell.tooltip}>
                  <span>
                    <Iconify icon={'quill:info'} />
                  </span>
                </Tooltip>
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
